export default "__VITE_ASSET__2f1ec62c__"